import { useSession } from '@hooks/session'
import { useOpenState } from '@hooks/open-state'

import { ClientGate } from '@elements/client-gate'
import { LoginModal } from '@modules/auth/views/login-modal'
import { LogoutModal } from '@modules/auth/views/logout-modal'
import { TablelistLogo } from '@icons/tablelist-logo'

export function LoginStatusButton() {
  const loginModal = useOpenState()
  const logoutModal = useOpenState()

  const { user, loggedIn } = useSession()

  return (
    <ClientGate>
      <a
        aria-label={`You ${loggedIn ? 'are' : 'are not'} logged in. Would you like to ${
          loggedIn ? 'logout' : 'login'
        }`}
        className='flex items-center space-x-2 text-base font-bold transition-colors cursor-pointer ring-2 ring-offset-0 ring-transparent focus:ring-primary-600 sm:text-md'
        onClick={loggedIn ? logoutModal.open : loginModal.open}
      >
        <TablelistLogo
          draw
          fill='currentColor'
          className='w-5 h-5 mr-2 stroke-2 sm:w-6 sm:h-6'
        />
        {loggedIn ? user?.firstName || 'Logout' : 'Login'}
      </a>
      <LoginModal {...loginModal} />
      <LogoutModal {...logoutModal} />
    </ClientGate>
  )
}
